<ng-template #bar>
   <mat-progress-bar id="ab-progress-bar"></mat-progress-bar>
</ng-template>

<ng-template #spinner>
   <mat-spinner diameter="30" id="ab-spinner"></mat-spinner>
</ng-template>

<ng-template #delete_confirm>
   <div class="buttons common-uppercase common-jcfe" id="ab-delete-confirm">
      Are you sure?
      <button mat-raised-button color="warn" (click)="delete()" class="common-ml1em" id="ab-confirm-delete">
         DELETE
      </button>
      <button mat-button (click)="deleting = false" id="ab-cancel-delete">CANCEL</button>
   </div>
</ng-template>


<div class="business" id="ab-business">
   <ng-container *ngIf="!loading else spinner">
      <ng-container *ngIf="!saving else spinner">
         <ng-container *ngIf="!deleting else delete_confirm">
            <div class="buttons" id="ab-buttons">
               <button mat-stroked-button routerLink="/addressbook" *ngIf="breakpoints.small" id="ab-cancel">
                  <mat-icon id="ab-icon-cancel">chevron_left</mat-icon> CANCEL
               </button>

               <button mat-raised-button color="primary" [disabled]="businessForm.invalid" (click)="save()" id="ab-save">
                  <mat-icon id="ab-icon-save">save</mat-icon> SAVE
               </button>

               <ng-container *ngIf="id">
                  <ng-container *ngIf="!breakpoints.xsmall else xsmallButtons">
                     <button mat-raised-button color="accent" routerLink="/addressbook/duplicate/{{id}}" id="ab-duplicate">
                        <mat-icon class="common-duplicateicon" id="ab-icon-duplicate">filter_none</mat-icon> DUPLICATE
                     </button>

                     <button mat-raised-button color="warn" (click)="deleting = true" class="common-mlauto" id="ab-delete">
                        <mat-icon id="ab-icon-delete">clear</mat-icon> DELETE
                     </button>
                  </ng-container>
               </ng-container>

               <mat-button-toggle-group
                  [value]="filter"
                  style="margin-right: 0; margin-left: auto;"
                  (change)="filterChange($event.value)"
                  id="ab-toggle-group"
               >
                  <mat-button-toggle style="width: inherit;" [value]="'all'" id="ab-toggle-all">
                     <mat-icon [svgIcon]="'shipments'" id="ab-icon-toggle-all"></mat-icon> ALL
                  </mat-button-toggle>
                  <mat-button-toggle style="width: inherit;" [value]="'account'" id="ab-toggle-account">
                     <mat-icon id="ab-icon-toggle-account">supervisor_account</mat-icon> ACCOUNT
                  </mat-button-toggle>
                  <mat-button-toggle style="width: inherit;" [value]="'personal'" id="ab-toggle-personal">
                     <mat-icon id="ab-icon-toggle-personal">person</mat-icon> PERSONAL
                  </mat-button-toggle>
               </mat-button-toggle-group>
            </div>

            <ng-template #xsmallButtons>
               <button mat-icon-button color="primary" [matMenuTriggerFor]="xsmallMenu" class="common-mlauto" id="ab-menu-button">
                  <mat-icon id="ab-icon-menu">more_vert</mat-icon>
               </button>

               <mat-menu #xsmallMenu id="ab-xsmall-menu">
                  <button mat-menu-item color="primary" *ngIf="id" routerLink="/addressbook/duplicate/{{id}}" id="ab-duplicate">
                     <mat-icon class="common-duplicateicon" id="ab-icon-menu-duplicate">filter_none</mat-icon> DUPLICATE
                  </button>
                  <button mat-menu-item color="warn" *ngIf="id" (click)="deleting = true" id="ab-delete">
                     <mat-icon color="warn" id="ab-icon-menu-delete">clear</mat-icon> DELETE
                  </button>
               </mat-menu>
            </ng-template>
         </ng-container>
      </ng-container>

      <form [formGroup]="businessForm" id="ab-business-form">
         <div class="business-form" id="ab-business-form-fields">
            <mat-form-field #type_field id="ab-type-field">
               <mat-label id="ab-label-type">Address Book Type</mat-label>
               <mat-select formControlName="type" required id="ab-type-select">
                  <mat-option [value]="'account'" id="ab-type-acc">Account</mat-option>
                  <mat-option [value]="'personal'" id="ab-type-per">Personal</mat-option>
               </mat-select>
            </mat-form-field>

            <mat-form-field #name_field id="ab-name-field">
               <mat-label id="ab-label-name">Location Name</mat-label>
               <input matInput id="ab-name" #name [required]="required?.name" [maxlength]="lengths?.name" formControlName="name">
               <mat-error libInputErrors [control]="businessForm.get('name')" id="ab-error-name"></mat-error>
               <mat-hint align="end" *ngIf="focused(name_field) && name?.value.length as l" id="ab-hint-name">{{l || 0}} / {{lengths?.name}}</mat-hint>
            </mat-form-field>

            <ng-container *ngIf="countries.countries | async else spinner">
               <mat-form-field #country_field id="ab-country-field">
                  <mat-label id="ab-label-country">Country</mat-label>
                  <mat-select formControlName="country" [required]="required?.country" id="ab-country-select">
                     <mat-option *ngFor="let country of countries.countries | async" [value]="country.code">{{country.country}}</mat-option>
                  </mat-select>
               </mat-form-field>

               <mat-form-field #address1_field id="ab-address1-field">
                  <mat-label id="ab-label-address1">Address Line 1</mat-label>
                  <input matInput id="ab-address1" #address1 [required]="required?.address1" [maxlength]="lengths?.address1" formControlName="address1">
                  <mat-error libInputErrors [control]="businessForm.get('address1')" id="ab-error-address1"></mat-error>
                  <mat-hint align="end" *ngIf="focused(address1_field) && address1?.value.length as l" id="ab-hint-address1">{{l || 0}} / {{lengths?.address1}}</mat-hint>
               </mat-form-field>

               <mat-form-field #address2_field id="ab-address2-field">
                  <mat-label id="ab-label-address2">Address Line 2</mat-label>
                  <input matInput id="ab-address2" #address2 [required]="required?.address2" [maxlength]="lengths?.address2" formControlName="address2">
                  <mat-error libInputErrors [control]="businessForm.get('address2')" id="ab-error-address2"></mat-error>
                  <mat-hint align="end" *ngIf="focused(address2_field) && address2?.value.length as l" id="ab-hint-address2">{{l || 0}} / {{lengths?.address2}}</mat-hint>
               </mat-form-field>

               <mat-form-field #address3_field id="ab-address3-field">
                  <mat-label id="ab-label-address3">Address Line 3</mat-label>
                  <input matInput id="ab-address3" #address3 [required]="required?.address3" [maxlength]="lengths?.address3" formControlName="address3">
                  <mat-error libInputErrors [control]="businessForm.get('address3')" id="ab-error-address3"></mat-error>
                  <mat-hint align="end" *ngIf="focused(address3_field) && address3?.value.length as l" id="ab-hint-address3">{{l || 0}} / {{lengths?.address3}}</mat-hint>
               </mat-form-field>

               <div class="business-form-line" id="ab-address-line2">
                  <mat-form-field #city_field id="ab-city-field">
                     <mat-label id="ab-label-city">City</mat-label>
                     <input matInput id="ab-city" #city [required]="required?.city" [maxlength]="lengths?.city" formControlName="city">
                     <mat-error libInputErrors [control]="businessForm.get('city')" id="ab-error-city"></mat-error>
                     <mat-hint align="end" *ngIf="focused(city_field) && city?.value.length as l" id="ab-hint-city">{{l || 0}} / {{lengths?.city}}</mat-hint>
                  </mat-form-field>

                  <mat-form-field #state_field *ngIf="(countries.country(country.value) | async)?.regions; else textRegion" id="ab-state-select-field">
                     <mat-label id="ab-label-state">Region</mat-label>
                     <mat-select formControlName="state" [required]="required?.state" id="ab-state-select">
                        <mat-option *ngFor="let state of (countries.country(country.value) | async)?.regions" [value]="state.code">
                           {{ state.region }}
                        </mat-option>
                     </mat-select>
                     <mat-error libInputErrors [control]="businessForm.get('state')" id="ab-error-state"></mat-error>
                  </mat-form-field>

                  <ng-template #textRegion>
                     <mat-form-field #state_field id="ab-state-input-field">
                        <mat-label id="ab-label-state-text">Region</mat-label>
                        <input matInput id="ab-state" #state formControlName="state" [required]="required?.state" />
                        <mat-error libInputErrors [control]="businessForm.get('state')" id="ab-error-state-text"></mat-error>
                        <mat-hint align="end" *ngIf="focused(state_field) && state?.value.length as l" id="ab-hint-state">{{l || 0}} / {{lengths?.state}}</mat-hint>
                     </mat-form-field>
                  </ng-template>

                  <mat-form-field #postalcode_field id="ab-postalcode-field">
                     <mat-label id="ab-label-postalcode">Postal Code</mat-label>
                     <input id="ab-postalcode" #postalcode matInput [placeholder]="(countries.country(country.value) | async)?.postalDetails?.postalExample" [required]="required?.postalcode" [maxlength]="lengths?.postalcode" formControlName="postalcode">
                     <mat-error libInputErrors [control]="businessForm.get('postalcode')" id="ab-error-postalcode"></mat-error>
                     <mat-hint align="end" *ngIf="focused(postalcode_field) && postalcode?.value.length as l" id="ab-hint-postalcode">{{l || 0}} / {{lengths?.postalcode}}</mat-hint>
                  </mat-form-field>
               </div>

               <div class="business-form-line" id="ab-contact-line">
                  <mat-form-field #phone_field id="ab-phone-field">
                     <mat-label id="ab-label-phone">Phone Number</mat-label>
                     <input matInput id="ab-phone" #phone formControlName="phone" [required]="required?.phone" [maxlength]="lengths?.phone">
                     <mat-error libInputErrors [control]="businessForm.get('phone')" id="ab-error-phone"></mat-error>
                     <mat-hint align="end" *ngIf="focused(phone_field) && phone?.value.length as l" id="ab-hint-phone">{{l || 0}} / {{lengths?.phone}}</mat-hint>
                  </mat-form-field>

                  <mat-form-field #fax_field id="ab-fax-field">
                     <mat-label id="ab-label-fax">Fax Number</mat-label>
                     <input matInput id="ab-fax" #fax formControlName="fax" [required]="required?.fax" [maxlength]="lengths?.fax">
                     <mat-error libInputErrors [control]="businessForm.get('fax')" id="ab-error-fax"></mat-error>
                     <mat-hint align="end" *ngIf="focused(fax_field) && fax?.value.length as l" id="ab-hint-fax">{{l || 0}} / {{lengths?.fax}}</mat-hint>
                  </mat-form-field>
               </div>
            </ng-container>
         </div>

         <lib-contacts [contacts]="businessForm.get('contacts')" id="ab-lib-contacts"></lib-contacts>
      </form>
   </ng-container>
</div>
